import type { BankingSDKLoggingRepositoryState } from "./types";
import { withState } from "../../Repository";

export const makeState = withState<BankingSDKLoggingRepositoryState>({
    data: null
});
